export default __webpack_public_path__ + "static/media/6.021f6075.jpg";